const FILTERED_VALUE = '[Filtered]';
const SENSITIVE_KEYS = ['cvv', 'card_number', 'expiration_date', 'jwt', 'refreshToken'];

type FilteredData = Record<string, unknown>;

const filterSensitiveDataFromObject = (dataToFilter: FilteredData): FilteredData => {
  const result: FilteredData = {
    ...dataToFilter,
  };

  SENSITIVE_KEYS.forEach(keyToFilter => {
    if (result[keyToFilter]) {
      result[keyToFilter] = FILTERED_VALUE;
    }
  });
  
  return result;
};

const filterSensitiveDataFromString = (dataToFilter: string) => {
  let result: string = dataToFilter;

  SENSITIVE_KEYS.forEach(keyToFilter => {
    const startIndex = result.indexOf(`"${keyToFilter}":`);
    if (startIndex !== -1) {
      const valueStart = result.indexOf(':', startIndex) + 1;
      const valueEnd = result.indexOf(',', valueStart) === -1
        ? result.indexOf('}', valueStart)
        : result.indexOf(',', valueStart);

      if (valueStart !== -1 && valueEnd !== -1) {
        result = result.substring(0, valueStart) + `"${FILTERED_VALUE}"` + result.substring(valueEnd);
      }
    }
  });

  return result;
};

const scrubRequestData = (requestData: FilteredData | string) => {
  if (!requestData) {
    return;
  }

  if (typeof requestData === 'string') {
    try {
      const filteredData = filterSensitiveDataFromObject(JSON.parse(requestData));

      return JSON.stringify(filteredData);
    } catch {
      // non-parsable string
      return filterSensitiveDataFromString(requestData);
    }
  }

  return filterSensitiveDataFromObject(requestData);
};

export default scrubRequestData;
